import { Archivo, IArchivo } from "./archivo.model";

export interface IEmpresa {
  idEmpresa: string;
  razonSocial: string;
  nombreComercial: string;
  domicilio1: string;
  domicilio2: string;
  ciudad: string;
  entidadFederativa: string;
  codigoPostal: string;
  contacto: string;
  telefono: string;
  correoElectronico: string;
  rfc: string;
  tipoPersona: string;
  regimenFiscal: string;
  usoCfdi: string;
  idArchivo?: string;
  estado: boolean;
  fechaCreacion: string;
  usuarioCreacion: string;
  fechaActualizacion: string;
  usuarioActualizacion: string;
  logo?: IArchivo;
}

export class Empresa {
  idEmpresa: string;
  razonSocial: string;
  nombreComercial: string;
  domicilio1: string;
  domicilio2: string;
  ciudad: string;
  entidadFederativa: string;
  codigoPostal: string;
  contacto: string;
  telefono: string;
  correoElectronico: string;
  rfc: string;
  tipoPersona: string;
  regimenFiscal: string;
  usoCfdi: string;
  idArchivo?: string;
  estado: boolean;
  fechaCreacion: Date;
  usuarioCreacion: string;
  fechaActualizacion: Date;
  usuarioActualizacion: string;
  logo?: Archivo;

  constructor(data: IEmpresa) {
    this.idEmpresa = data.idEmpresa;
    this.razonSocial = data.razonSocial;
    this.nombreComercial = data.nombreComercial;
    this.domicilio1 = data.domicilio1;
    this.domicilio2 = data.domicilio2;
    this.ciudad = data.ciudad;
    this.entidadFederativa = data.entidadFederativa;
    this.codigoPostal = data.codigoPostal;
    this.contacto = data.contacto;
    this.telefono = data.telefono;
    this.correoElectronico = data.correoElectronico;
    this.rfc = data.rfc;
    this.tipoPersona = data.tipoPersona;
    this.regimenFiscal = data.regimenFiscal;
    this.usoCfdi = data.usoCfdi;
    this.idArchivo = data.idArchivo;
    this.estado = data.estado;
    this.fechaCreacion = new Date(data.fechaCreacion);
    this.usuarioCreacion = data.usuarioCreacion;
    this.fechaActualizacion = new Date(data.fechaActualizacion);
    this.usuarioActualizacion = data.usuarioActualizacion;
    this.logo = data.logo 
      ? new Archivo(data.logo) 
      : undefined;
  }
}
